import * as addressActions from './addressActions';
import * as alertActions from './alertActions';
import * as attachmentActions from './attachmentActions';
import * as billingActions from './billingActions';
import * as customerActions from './customerActions';
import * as customViewActions from './customViewActions';
import * as devAccessActions from './devAccessActions';
import * as equipmentActions from './equipmentActions';
import * as estimateActions from './estimateActions';
import * as inventoryByLocationActions from './inventoryByLocationActions';
import * as inventoryItemActions from './inventoryItemActions';
import * as inventoryLocationActions from './inventoryLocationActions';
import * as invoiceActions from './invoiceActions';
import * as leadActions from './leadActions';
import * as logActions from './logActions';
import * as myAccountActions from './myAccountActions';
import * as paymentActions from './paymentActions';
import * as portalActions from './portalActions';
import * as priceListActions from './priceListActions';
import * as priceListItemActions from './priceListItemActions';
import * as processorActions from './processorActions';
import * as settingsActions from './settingsActions';
import * as staffActions from './staffActions';
import * as tableActions from './tableActions';
import * as taxActions from './taxActions';
import * as teamActions from './teamActions';
import * as templateActions from './templateActions';
import * as ticketActions from './ticketActions';
import * as unitsActions from './unitsActions';
import * as userActions from './userActions';

import request from '../api/request';
import {handleError} from '../helpers';

export const asyncLoad = async ({dispatch, params = {}, title, url}) => {
  try {
    const response = await request({url, ...params});

    return response && response.data ? response.data : null;
  } catch (error) {
    handleError(`Unable to load ${title}`, error, dispatch);
  }
};

export const asyncPost = async ({
  body,
  dispatch,
  params = {},
  successMessage = null,
  title,
  url,
  errorPrefix = 'An error occurred',
}) => {
  try {
    const response = await request({url, body, method: 'POST', ...params});

    // 50002: IgnoredException
    if (response && response.data && response.data.code === 50002) {
      return null;
    }

    if (response && response.status >= 400) {
      if (response.data) {
        handleError(errorPrefix, response.data, dispatch);
        return {error: true};
      }

      throw new Error(
        response.data && response.data.message
          ? response.data.message
          : response.data,
      );
    }

    if (successMessage) {
      dispatch(alertActions.success(successMessage));
    }

    return response;
  } catch (error) {
    handleError(`Unable to save ${title}`, error, dispatch);
    return {error: true};
  }
};

export const asyncPatch = async ({
  body,
  dispatch,
  params,
  successMessage = null,
  title,
  url,
}) => {
  try {
    const response = await request({url, body, method: 'PATCH', ...params});

    if (!response) {
      throw new Error('no response');
    }

    if (response.status >= 400) {
      throw new Error(
        response.data && response.data.message
          ? response.data.message
          : response.data,
      );
    }

    if (successMessage) {
      dispatch(alertActions.success(successMessage));
    }

    return response;
  } catch (error) {
    handleError(`Unable to update ${title}`, error, dispatch);
  }
};

export const asyncDelete = async ({
  dispatch,
  successMessage = null,
  title,
  url,
  params,
}) => {
  try {
    const response = await request({url, method: 'DELETE', ...params});

    if (response && response.status >= 400) {
      throw new Error(
        response.data && response.data.message
          ? response.data.message
          : response.data,
      );
    }

    if (successMessage) {
      dispatch(alertActions.success(successMessage));
    }

    return response || true;
  } catch (error) {
    handleError(`Unable to delete ${title}`, error, dispatch);
    return false;
  }
};

export {
  addressActions,
  alertActions,
  attachmentActions,
  billingActions,
  customerActions,
  customViewActions,
  devAccessActions,
  equipmentActions,
  estimateActions,
  inventoryByLocationActions,
  inventoryItemActions,
  inventoryLocationActions,
  invoiceActions,
  leadActions,
  logActions,
  myAccountActions,
  paymentActions,
  portalActions,
  priceListActions,
  priceListItemActions,
  processorActions,
  settingsActions,
  staffActions,
  tableActions,
  taxActions,
  teamActions,
  templateActions,
  ticketActions,
  unitsActions,
  userActions,
};



// WEBPACK FOOTER //
// ./src/actions/index.js